const snackbar = {
  methods: {
    sendMessage(type, message) {
      this.snackbar.color = type;
      this.snackbar.message = message;
      this.snackbar.open = true;
    },
  },
  data() {
    return {
      snackbar: {
        open: false,
        message: '',
        color: null,
      },
    };
  },
};

export default snackbar;
